/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_During_DescInputs */



/**
* | output |
* | --- |
* | "A notetaker that follows along, so you don't have to take notes yourself and can stay fully present. You decide for each conversation whether to switch it on..." |
*
* @param {Onboarding_Value_During_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_during_desc = /** @type {((inputs?: Onboarding_Value_During_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_During_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een notetaker die meeschrijft, zodat je zelf niet hoeft te noteren en volledig bij het gesprek kan zijn. Je kiest per gesprek of je de notetaker inschakelt. Voor deelnemers is dat altijd zichtbaar. Achteraf krijg je van Wundo feedback en coaching over hoe het gesprek verliep.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un notetaker qui écrit pour vous, pour que vous n’ayez rien à noter et que vous soyez pleinement présent. Vous choisissez pour chaque conversation si vous l’activez. Les participants le voient toujours. Ensuite, Wundo vous donne du feedback et du coaching sur le déroulement de la conversation.")
	return /** @type {LocalizedString} */ ("A notetaker that follows along, so you don't have to take notes yourself and can stay fully present. You decide for each conversation whether to switch it on and everyone in the meeting can always see when it's active. Afterwards, Wundo gives you feedback and coaching on how the conversation went.")
});